import { useRecoilValue } from 'recoil';
import { StructureSet } from '~/domain/patient/structureset';
import { detachedContourResultsState } from '~/state/atoms/detachedContourResultsAtom';
import { jobQueueState } from '~/state/atoms/jobAtoms';

export type DetachedContourRun =
    | { readonly kind: 'none' }
    | { readonly kind: 'pending' }
    | { readonly kind: 'cancelled' }
    | { readonly kind: 'ready'; readonly structureSet: StructureSet }
    | {
          readonly kind: 'failed';
          readonly messageId: string;
          readonly detail?: string;
      };

const NONE: DetachedContourRun = { kind: 'none' };
const PENDING: DetachedContourRun = { kind: 'pending' };
const CANCELLED: DetachedContourRun = { kind: 'cancelled' };

export function useDetachedContourRun(jobId?: string): DetachedContourRun {
    const results = useRecoilValue(detachedContourResultsState);
    const { jobs } = useRecoilValue(jobQueueState);
    if (!jobId) {
        return NONE;
    }
    const result = results[jobId];
    if (result) {
        return result;
    }
    const job = jobs.find((candidate) => candidate.id === jobId);
    if (!job) {
        return { kind: 'failed', messageId: 'replanning.contour.notQueued' };
    }
    if (job.status === 'Error') {
        return {
            kind: 'failed',
            messageId: 'replanning.contour.failed',
            detail: job.error,
        };
    }
    if (job.status === 'Canceled') {
        return CANCELLED;
    }
    return PENDING;
}
